import { useEffect, useState } from "react"
import { SaveLaterApi } from "../../apis/posts/save_later_api";
import { API_STATUS } from "../../constants";
import { Link } from "react-router-dom";
import { PostShareCountStatus } from "../../apis/posts/post_share_count_status";
import { PostLikeCountStatus } from "../../apis/posts/post_like_count_status";
import { ArchivePostStatus } from "../../apis/posts/archive_post_status";
import { DeletePostApi } from "../../apis/posts/delete_post_api";
import { RemoveLaterApi } from "../../apis/posts/remove_later_api";

export default function PostBoxHeader({ item, esave, setShowLike, setShowShare, setShowPost, showShare, showLike, setEdit, setEditItem }) {
    const [loginId, setLoginId] = useState("");
    const [acode, setAcode] = useState("");
    const [saved, setSaved] = useState(0);
    const [saveApi, setSaveApi] = useState(API_STATUS);


    useEffect(() => {
        const userCode = sessionStorage.getItem('USER_CODE');
        setLoginId(userCode);

        const login_data = sessionStorage.getItem('LOGIN_DATA');
        const udata = JSON.parse(login_data);
        setAcode(udata['access']);

        if (esave != null) {
            if (esave) {
                setSaved(1);
            }
        }

    }, []);

    useEffect(() => {
        setShowLike(item.p_like_count);
        setShowShare(item.p_share_cstatus);
    }, []);


    return <div className="flex gap-3 sm:p-4 p-2.5 text-sm font-medium">
        <a href={'/profile/' + item.u_token}> <img src={item.user_pic} alt="" class="w-9 h-9 rounded-full" /> </a>

        <div className="flex-1" style={{ display: 'flex', alignItems: 'center' }}>
            <a href={'/profile/' + item.u_token}> <h4 className="text-black dark:text-white"> {item.first_name} {item.last_name} </h4></a>
            {
                item['subId'] != null && item['subPayStatus'] == 1 &&
                <span style={{ color: '#17ce85ff', fontSize: 14, paddingLeft: 5 }}><i class="fa fa-check-circle" aria-hidden="true"></i></span>
            }
        </div>
        <div className="-mr-1">
            <button type="button" className="button__ico w-8 h-8"> <ion-icon className="text-xl" name="ellipsis-horizontal"><i className="fa fa-ellipsis-h"></i></ion-icon> </button>
            <div className="w-[245px]" uk-dropdown="pos: bottom-right; animation: uk-animation-scale-up uk-transform-origin-top-right; animate-out: true; mode: click">
                {
                    item.u_token === loginId &&
                    <nav>
                        {
                            item.p_status === 1 &&
                            <Link
                                onClick={() => {
                                    setShowPost(0);
                                    ArchivePostStatus({ 'status': 0, 'pid': item.p_id }, setSaveApi);
                                }}
                            > <ion-icon className="text-xl shrink-0" name="bookmark-outline"></ion-icon>  Archive </Link>
                        }
                        {
                            item.p_status === 0 &&
                            <Link
                                onClick={() => {
                                    setShowPost(0);
                                    ArchivePostStatus({ 'status': 1, 'pid': item.p_id }, setSaveApi);
                                }}
                            > <ion-icon className="text-xl shrink-0" name="bookmark-outline"></ion-icon>  Unarchive </Link>
                        }
                        <Link
                            onClick={() => {
                                if (showLike == 1) {
                                    setShowLike(0);
                                    PostLikeCountStatus({ 'status': 0, 'pid': item.p_id }, setSaveApi);
                                } else {
                                    setShowLike(1);
                                    PostLikeCountStatus({ 'status': 1, 'pid': item.p_id }, setSaveApi);
                                }
                            }}
                        > <ion-icon className="text-xl shrink-0" name="notifications-off-outline"></ion-icon> {showLike === 1 ? 'Hide Like Count' : 'Show Like Count'} </Link>
                        <Link
                            onClick={() => {
                                if (showShare == 1) {
                                    setShowShare(0);
                                    PostShareCountStatus({ 'status': 0, 'pid': item.p_id }, setSaveApi);
                                } else {
                                    setShowShare(1);
                                    PostShareCountStatus({ 'status': 1, 'pid': item.p_id }, setSaveApi);
                                }
                            }}
                        > <ion-icon className="text-xl shrink-0" name="flag-outline"></ion-icon>  {showShare === 1 ? 'Hide Share Count' : 'Show Share Count'} </Link>
                        <Link
                            onClick={() => {
                                setEdit(true);
                                setEditItem(item);
                            }}
                        > <ion-icon className="text-xl shrink-0" name="share-outline"></ion-icon>  Edit </Link>
                        <hr />
                        <Link
                            onClick={() => {
                                setShowPost(0);
                                DeletePostApi({ 'status': 0, 'pid': item.p_id,'acode':acode }, setSaveApi);
                            }} className="text-red-400 hover:!bg-red-50 dark:hover:!bg-red-500/50"> <ion-icon className="text-xl shrink-0" name="stop-circle-outline"></ion-icon>  Delete </Link>
                    </nav>
                }

                {
                    item.u_token !== loginId &&
                    <nav>
                        {
                            saved === 1 &&
                            <button
                                onClick={() => {
                                    RemoveLaterApi({ 'type': 'Post', 'id': item.p_id }, setSaveApi);
                                    setShowPost(0);
                                }}
                            > <ion-icon className="text-xl shrink-0" name="bookmark-outline"></ion-icon>Remove Saved</button>
                        }
                        {
                            saved === 0 &&
                            <button
                                onClick={() => {
                                    SaveLaterApi({ 'type': 'Post', 'id': item.p_id }, setSaveApi);
                                    setSaved(1);
                                }}
                            > <ion-icon className="text-xl shrink-0" name="bookmark-outline"></ion-icon>Save </button>
                        }

                    </nav>
                }

            </div>
        </div>
    </div>
}